import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Carousel from "react-elastic-carousel";
import styles from './slider.module.css';
import Link from "next/link";

var Slider = function Slider(_ref) {
  var setting = _ref.setting;
  var breakPoints = [//from the breakpoint and up it will effect
  {
    width: 340,
    itemsToShow: 2.5
  }, {
    width: 390,
    itemsToShow: 3.5
  }, {
    width: 414,
    itemsToShow: 3
  }, {
    width: 490,
    itemsToShow: 4
  }, {
    width: 550,
    itemsToShow: 5
  }, {
    width: 668,
    itemsToShow: 6
  }, {
    width: 1200,
    itemsToShow: 7
  }, {
    width: 1300,
    itemsToShow: 8
  }, {
    width: 1500,
    itemsToShow: 8
  }];
  return /*#__PURE__*/_jsxs("div", {
    className: "home-slider position-relative ".concat(setting.className),
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.container,
      children: /*#__PURE__*/_jsx(Carousel, {
        enableAutoPlay: true,
        autoPlaySpeed: 3200,
        breakPoints: breakPoints,
        children: setting.items.map(function (item, index) {
          return /*#__PURE__*/_jsx("div", {
            className: "".concat(styles.wrapper),
            children: /*#__PURE__*/_jsx(Link, {
              href: "/start",
              children: /*#__PURE__*/_jsx("a", {
                children: /*#__PURE__*/_jsx("img", {
                  src: item
                })
              })
            })
          }, index);
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.shelf
    })]
  });
};

export default Slider;